"use client";

import React, { useEffect, useState } from "react";
import { motion } from 'framer-motion';
import ai01 from '../../assets/images/about/book01.png';
import ai02 from '../../assets/images/about/book02.png';
import ai03 from '../../assets/images/about/book03.png';

export function InnovativeApproach() {
  const [selectedImage, setSelectedImage] = useState(ai01);

  useEffect(() => {
    const aiImages = [ai01, ai02, ai03];
    const randomIndex = Math.floor(Math.random() * aiImages.length);
    setSelectedImage(aiImages[randomIndex]);
  }, []);

  return (
    <section id="innovative-approach" className="relative px-[5%] py-16 md:py-24 lg:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-blue-900/20 via-transparent to-blue-900/20" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(59,130,246,0.1)_0%,transparent_70%)]" />
      
      <div className="container relative">
        <div className="grid grid-cols-1 gap-y-12 md:grid-cols-2 md:items-center md:gap-x-12 lg:gap-x-20">
          <div className="relative z-10">
            <div className="mb-8">
              <motion.h2 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="inline-flex items-center rounded-full bg-blue-400/10 px-4 py-1.5 text-sm font-medium text-blue-400 ring-1 ring-inset ring-blue-400/20"
              >
                Our Innovative Approach
              </motion.h2>
            </div>
            <h2 className="mb-5 text-4xl font-bold md:mb-6 md:text-5xl lg:text-6xl bg-gradient-to-br from-white to-gray-400 bg-clip-text text-transparent">
              The Perfect Blend of Human Expertise and AI
            </h2>
            <p className="md:text-md text-gray-300 leading-relaxed">
                By combining state-of-the-art AI platforms (Claude Opus, GPT-4, Deepseek, Stable Diffusion, DALL-E, Sora) with AI-enhanced development environments like Cursor and Windsurf, we've created a uniquely powerful workflow. Backed by decades of hands-on development expertise, this synergy of human insight and AI capabilities enables us to deliver exceptional results at unprecedented speed - without compromising on quality.
            </p>
          </div>
          
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg blur opacity-30 group-hover:opacity-40 transition duration-1000 group-hover:duration-200" />
            
            <div className="relative aspect-[4/3] overflow-hidden rounded-lg">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(59,130,246,0.3)_0%,transparent_70%)] z-10" />
              
              <img
                src={selectedImage}
                className="h-full w-full object-cover transform transition-transform duration-700 group-hover:scale-105"
                alt="AI-augmented development visualization"
              />
              
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-transparent to-gray-900/80" />
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-blue-500/10 to-transparent" />
              
              <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iMSIgZmlsbD0icmdiYSgyNTUsIDI1NSwgMjU1LCAwLjIpIi8+PC9zdmc+')] opacity-50" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}